"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = void 0;
var _react = _interopRequireWildcard(require("react"));
var _state = require("../../../../state");
var _Body = require("../Body");
var _layout = require("../../../layout");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Layout = function Layout(_ref) {
  var Header = _ref.headerComponent,
    Footer = _ref.footerComponent,
    children = _ref.children;
  var _useUser = (0, _state.useUser)(),
    user = _useUser.user,
    loading = _useUser.loading,
    fetchUser = _useUser.fetchUser;
  var userLoading = loading || !user;
  (0, _react.useEffect)(function () {
    fetchUser();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "min-vh-100 d-flex flex-column"
  }, /*#__PURE__*/_react.default.createElement(_layout.LayoutHeaderContainer, {
    className: userLoading ? 'd-flex flex-grow-1' : ''
  }, /*#__PURE__*/_react.default.createElement(Header, {
    userLoading: userLoading,
    userEmail: user === null || user === void 0 ? void 0 : user.credentials.email
  })), /*#__PURE__*/_react.default.createElement(_layout.LayoutBodyContainer, {
    className: "d-flex flex-grow-1"
  }, /*#__PURE__*/_react.default.createElement(_Body.Body, {
    className: "w-100"
  }, children)), /*#__PURE__*/_react.default.createElement(_layout.LayoutFooterContainer, null, /*#__PURE__*/_react.default.createElement(Footer, null)));
};
exports.Layout = Layout;